module.exports = __webpack_public_path__ + "img/play.8dc40cde.svg";